export const dateFieldFormatter = ({ value }) => dateTimeFormatter(value);
export const dateTimeFormatter = (value) => {
  const date = new Date(value);

  return `${date.toLocaleDateString()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
};

export const dateFormatter = value => new Date(value).toLocaleDateString();

export const numberProps = {
  formatter: ({ value }) => numberFormatter(value),
  class: 'text-end',
};
export const numberFormatter = value => value?.toLocaleString();

export const compactNumberFormatter = (value) => {
  if (value >= 10_000) {
    return `${(value / 1_000).toFixed(1)}k`;
  }

  return value.toLocaleString();
};
